import { useGetCurrentUserQuery } from 'utils/wemble-api';
import organization, { canViewExperience as checkExperience } from 'utils/organization';

/**
 * General permissions for the current user. canViewMatters/canViewHours are for viewing
 * OTHER people's data — own-profile access is always allowed and checked in the component.
 *
 * TODO: Move feature flags from the hardcoded organization.ts switch statement into the
 * Company model (a `features` field). Serve them via getCurrentUser/CompanyDto so they
 * refresh with the token. This hook then reads from the company data instead of the
 * static config. Eventually expose in the Wemble admin UI so firms can self-manage
 * feature toggles (experienceView, enableDetailedViewHours, etc.) without a deploy.
 * Migrate one flag at a time — organization.ts shrinks gradually.
 */
export default function usePermissions() {
  const { data: currentUser } = useGetCurrentUserQuery();
  const org = organization(currentUser?.company);
  const isAdmin = !!(currentUser?.admin || currentUser?.companyAdmin || currentUser?.administratorPriviliges);

  // Firms that open experience to everyone (experienceView === 'all') also get
  // matter visibility for everyone — matters are the same category of data as
  // the experience profile. Hours remain gated separately.
  const experienceOpenToAll = org.experienceView === 'all';

  return {
    currentUser,
    org,
    isAdmin,
    canViewExperience: checkExperience(org, currentUser?.email, isAdmin),
    canViewMatters: !!org.enableUtilizationView && (
      !!currentUser?.detailedViewPriviliges
      || (!!org.detailedViewAdminDefault && isAdmin)
      || experienceOpenToAll
    ),
    canViewHours: !!org.enableDetailedViewHours && (!!currentUser?.detailedViewHoursPriviliges || (!!org.detailedViewAdminDefault && isAdmin)),
  };
}
